module.exports = "/_next/static/resources/photo-1-b1b02a266d4881957aa9bf5058bb086d.jpg";